'use strict'

import {normalizeProductMetalKey} from './display'

const isPositiveNumber = (value) => Number.isFinite(value) && value > 0

const isValidPurityFraction = (value) => (
  Number.isFinite(value) && value > 0 && value <= 1
)

/** Catalog product unit weight (toz) from Product-shaped fields. */
export function catalogUnitWeightFromProduct(product) {
  const weight = Number(product?.weightToz ?? product?.weight)
  return isPositiveNumber(weight) ? weight : null
}

/**
 * Catalog purity as a 0–1 fraction from Product-shaped fields.
 * Object purity maps use metal keys; scalar purity is treated as a fraction.
 */
export function catalogPurityFractionFromProduct(product, metalKey = null) {
  const metal = metalKey || normalizeProductMetalKey(product)
  const raw = product?.purity && typeof product.purity === 'object'
    ? product.purity[metal]
    : product?.purity
  const fraction = Number(raw)
  return isValidPurityFraction(fraction) ? fraction : null
}

export function isCatalogProductWeightMissing(product) {
  return catalogUnitWeightFromProduct(product) === null
}

export function isCatalogProductPurityMissing(product, metalKey = null) {
  return catalogPurityFractionFromProduct(product, metalKey) === null
}

/** Prefer explicit override, else catalog product weight. */
export function resolveCatalogUnitWeightToz(product, explicitUnitWeightToz = null) {
  const explicit = Number(explicitUnitWeightToz)
  if (isPositiveNumber(explicit)) return explicit
  return catalogUnitWeightFromProduct(product)
}

/** Prefer explicit override, else supplied catalog fraction, else product. */
export function resolveCatalogPurityFraction(
  product,
  {
    metalKey = null,
    catalogPurityFraction = null,
    purityFraction = null,
  } = {},
) {
  const explicit = Number(purityFraction)
  if (isValidPurityFraction(explicit)) return explicit
  const supplied = Number(catalogPurityFraction)
  if (isValidPurityFraction(supplied)) return supplied
  return catalogPurityFractionFromProduct(product, metalKey)
}

export const __testing__ = Object.freeze({
  isPositiveNumber,
  isValidPurityFraction,
})
